// extracted by mini-css-extract-plugin
export var dividerLine = "_5l-0";
export var errorBackground = "_5l-1";